export const PLATFORM_FEATURE_FLAGS = [
    {
        key: 'calendar',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'time/calendar',
        description: 'Master flag. Off → every /calendar/events route returns 422 CALENDAR_DISABLED. Source materialisation subscribers stay registered (so the activity stream keeps a clean record), but the routes refuse traffic.',
        schemaVersion: 1,
    },
    {
        key: 'calendar.recurrence',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'time/calendar',
        description: 'Allow non-null `recurrence` (RFC 5545 RRULE) on custom events. Off → the route layer rejects RRULE bodies and the SPA hides repeat controls.',
        schemaVersion: 1,
    },
    {
        key: 'calendar.event-reminders',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'time/calendar',
        description: 'Cron job that scans calendar_events using each row reminder lead time and dispatches in-app `calendar.event-reminder` notifications. Off → reminder inputs are hidden and no notifications are emitted.',
        schemaVersion: 1,
    },
    {
        key: 'scheduling',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'time/scheduling',
        description: 'Master flag for host pages, availability windows, bookings, waitlist promotion, scheduling calendar mirrors, and scheduling notifications.',
        schemaVersion: 1,
    },
    {
        key: 'scheduling.waitlist',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'time/scheduling',
        description: 'Allow full group sessions to accept waitlisted bookings and promote the oldest waitlisted booking when a confirmed booking is cancelled.',
        schemaVersion: 1,
    },
    {
        key: 'coordination',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'time/coordination',
        description: 'Master flag for group availability coordination polls, multi-round slot voting, calendar commits, and coordination notifications.',
        schemaVersion: 1,
    },
    {
        key: 'coordination.survey-bridge',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'time/coordination',
        description: 'Allow surveys to embed availability coordination questions while keeping canonical slot votes in coordination tables.',
        schemaVersion: 1,
    },
    {
        key: 'search',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'platform/search',
        description: 'Enable the unified server-side search endpoint. V1 uses Postgres substring queries plus LinkableKind/canRead filtering; later adapters can swap in MeiliSearch behind the same contract.',
        schemaVersion: 1,
    },
    {
        key: 'search.suggestions',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'platform/search',
        description: 'Enable lightweight autocomplete suggestions for the topbar command/search dialog.',
        schemaVersion: 1,
    },
    {
        key: 'analytics.realtime',
        defaultValue: false,
        scope: 'global',
        ownerModule: 'platform/analytics',
        description: 'Enable realtime analytics visitor counts.',
        schemaVersion: 1,
    },
    {
        key: 'analytics.funnels',
        defaultValue: false,
        scope: 'global',
        ownerModule: 'platform/analytics',
        description: 'Enable configurable funnel reports.',
        schemaVersion: 1,
    },
    {
        key: 'analytics.export-csv',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'platform/analytics',
        description: 'Allow CSV export from analytics views.',
        schemaVersion: 1,
    },
    {
        key: 'webhooks.outbound',
        defaultValue: false,
        scope: 'global',
        ownerModule: 'platform/webhooks',
        description: 'Enable outbound webhook delivery attempts.',
        schemaVersion: 1,
    },
    {
        key: 'webhooks.signature-required',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'platform/webhooks',
        description: 'Sign webhook payloads with HMAC-SHA256.',
        schemaVersion: 1,
    },
];
//# sourceMappingURL=registry-platform.js.map